import gsap from 'gsap'
import { isSafariBrowser, isFirefoxBrowser } from './utilities'
export class Load {
  constructor(delay) {
    this.init(delay)
  }
  init(delay) {
    const tl = gsap.timeline({ delay: delay })
    const logo = document.querySelector('.header__home')
    const menuBar = document.querySelector('.header__menu')
    const logoWords = document.querySelectorAll('.header__word')
    const banner = document.querySelector('.banner__image-holder, .new-york-competition-banner .inner')
    const heading = document.querySelectorAll('.banner__heading .word, .banner__positioned-content-heading .word, .new-york-competition-banner .word')
    const fadeItems = document.querySelectorAll('.banner__positioned-content .fade-item')
    const menu = document.querySelectorAll('.header__menu-item')

    tl.add(() => {
      document.documentElement.classList.add('dom-ready')
      if (isSafariBrowser()) document.documentElement.classList.add('is-safari')
      if (isFirefoxBrowser()) document.documentElement.classList.add('is-firefox')
    })

    tl.to(banner, {
      duration: 1.4,
      ease: 'power2.inOut',
      clipPath: window.innerWidth < 650 ? 'inset(0.875rem)' : 'inset(1.625rem)'
    }, 0)

    tl.fromTo(menu, {
      yPercent: 100
    }, {
      duration: 0.5,
      yPercent: 0,
      stagger: 0.15,
      ease: 'power1.out'
    }, 0.4)

    tl.fromTo(menuBar, {
      clipPath: 'inset(0 0 100% 100%)'
    }, {
      clipPath: 'inset(0 0 0% 0%)',
      duration: 1.4,
      ease: 'power2.inOut',
    }, 0.2)

    tl.from(heading, {
      duration: 1.4,
      yPercent: 105,
      stagger: 0.1,
      ease: 'power4.out',
    }, 0.4)

    tl.fromTo(fadeItems, {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 1.8,
      ease: 'power4.out',
    }, 0.8)

    tl.to(logoWords, {
      duration: 0.8,
      yPercent: 0,
      stagger: 0.1,
      ease: 'power4.out',
      clearProps: 'all',
    }, 0.75)

    tl.from(logo, {
      duration: 1.4,
      ease: 'power2.inOut',
      clearProps: 'all',
      clipPath: 'inset(0 100% 100% 0)',
    }, 0)
  }
}

export default () => {}